import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Supplies the workflow display name for /workflows/:id while the layout breadcrumb renders. */
@Injectable({ providedIn: 'root' })
export class WorkflowDetailBreadcrumbService {
    private readonly _label$ = new BehaviorSubject<string | null>(null);

    readonly label$ = this._label$.asObservable();

    setWorkflowLabel(label: string | null): void {
        this._label$.next(label);
    }

    getWorkflowLabel(): string | null {
        return this._label$.value;
    }
}
